import React, { useEffect, useState } from "react";
import Select from "react-select";
import * as Components from "../../../components/all";

import { useNavigate } from "react-router-dom";

import { AiFillEye } from "react-icons/ai";
import { HiOfficeBuilding } from "react-icons/hi";

export default function Admins() {
	const navigate = useNavigate();
	// eslint-disable-next-line no-unused-vars
	const [loading, setLoading] = useState(false);

	// Users Data
	var adminsData = {
		totalPS: 175,
		activePS: 170,
		allPS: [
			{
				id: 1,
				ps: "Comsats University Islamabad",
				city: "Islamabad",
				admins: 2,
			},
			{
				id: 2,
				ps: "Iqra University Islamabad",
				city: "Islamabad",
				admins: 1,
			},
			{
				id: 3,
				ps: "Hamdard University Islamabad",
				city: "Islamabad",
				admins: 2,
			},
			{
				id: 4,
				ps: "Abasyn University Islamabad",
				city: "Islamabad",
				admins: 1,
			},
		],
		allAdmins: [
			{
				id: 1,
				name: "Admin 1",
				status: "active",
				ps: "Comsats University Islamabad",
			},
			{
				id: 2,
				name: "Admin 2",
				status: "active",
				ps: "Comsats University Islamabad",
			},
			{
				id: 3,
				name: "Admin 1",
				ps: "Iqra University Islamabad",
				status: "suspended",
			},
		],
	};

	// settings
	var settings = {
		selectStyles: {
			control: (provided, state) => ({
				...provided,
				minHeight: "30px",
				height: "30px",
				boxShadow: state.isFocused ? null : null,
			}),

			valueContainer: (provided, state) => ({
				...provided,
				height: "30px",
				padding: "0 8px 0 8px",
			}),

			input: (provided, state) => ({
				...provided,
				margin: "0px",
			}),

			indicatorSeparator: (state) => ({
				display: "none",
			}),

			indicatorsContainer: (provided, state) => ({
				...provided,
				height: "30px",
			}),
		},
	};

	// Search Feature
	const [filteredAdmins, setFilteredAdmins] = useState(adminsData.allAdmins);
	const search = (term) => {
		if (term === "") {
			setFilteredAdmins(adminsData.allAdmins);
			return;
		}

		const filtered = adminsData.allAdmins.filter(
			(x) => x.ps.toLowerCase().indexOf(term.toLowerCase()) > -1
		);
		setFilteredAdmins(filtered);
	};

	// get PS
	const getPS = () => {
		var x = [];
		adminsData.allPS.map((ps) => {
			if (ps.admins < 2) {
				x.push({
					value: ps.id.toString(),
					label: (ps.ps + ", " + ps.city).toString(),
				});
			}
		});
		return x;
	};

	// generate Password
	function generatePassword() {
		var chars =
			"0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
		var passwordLength = 12;
		var password = "";
		for (var i = 0; i <= passwordLength; i++) {
			var randomNumber = Math.floor(Math.random() * chars.length);
			password += chars.substring(randomNumber, randomNumber + 1);
		}

		setNewAdmin((prev) => ({ ...prev, password: password }));
	}

	// New Admin
	const [newAdmin, setNewAdmin] = useState({
		name: null,
		ps: null,
		password: null,
	});

	const createNewAdmin = () => {
		if (
			newAdmin.name === null ||
			newAdmin.ps === null ||
			newAdmin.password === null
		) {
			alert("Fill all fields !");
			return;
		}

		if (newAdmin.password.length < 8) {
			alert("Password must have atleast 8 characters !");
			return;
		}

		alert(newAdmin.ps + "\n" + newAdmin.name + "\n" + newAdmin.password);
	};

	// Suspend User
	const suspendAdmin = async (id) => {
		var choice = prompt("Press 'y' if you want to suspend the user:");
		if (choice === "y" || choice === "Y") {
		}
	};

	// Activate User
	const activateAdmin = async (id) => {
		var choice = prompt("Press 'y' if you want to active the user:");
		if (choice === "y" || choice === "Y") {
		}
	};

	return loading === true ? (
		<Components.Loader />
	) : (
		<div
			className="Admins
            overflow-x-hidden overflow-y-auto 
            h-full 
            w-full
            sm:p-3 md:p-5
            flex flex-row flex-wrap
            "
		>
			{/* LEFT CARDS ROW */}
			<div
				className="LEFT-CARDS 
				flex flex-col
				sm:flex-[1]
				sm:min-w-[420px] 
				max-sm:w-full
				"
			>
				{/* left top cards */}
				<div className="LEFT-TOP-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap flex-[1]">
					{/* card 1 */}
					<div
						style={{
							boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
						}}
						className="
					min-h-[120px] 
					sm:min-w-[300px] flex-1                    rounded-md
                    p-5 m-2
                    bg-white 
                    flex flex-col
                    "
					>
						{/* heading */}
						<div className="flex items-center">
							<div
								className="
                            h-6 w-6 
                            flex items-center justify-center
                            rounded-full
                            bg-[#DBF6ED] 
                            text-[#8DBEAD]
                            "
							>
								<HiOfficeBuilding />
							</div>

							<h1 className="ml-2 text-darker">Parking Spaces</h1>
						</div>

						{/* data */}
						<div className="flex items-center justify-between mt-auto">
							<h1 className="text-3xl font-medium tracking-tighter">
								{adminsData.totalPS.toLocaleString()}
							</h1>

							<div className="">
								<h1 className="text-[#CCCCCC] text-sm font-medium opacity-70 mr-1">
									Currently Active
								</h1>

								<div className="flex items-center justify-center">
									{adminsData.activePS > 0 ? (
										<h1 className="ml-1 text-green-400">
											{adminsData.activePS}
										</h1>
									) : (
										<h1 className="ml-1 text-red-400">{adminsData.activePS}</h1>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* left bottom cards */}
				<div className="LEFT-BOTTOM-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap flex-[5]">
					{/* card 1 */}
					<div
						style={{
							boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
						}}
						className="
						min-h-[400px] sm:min-h-[520px] 
						sm:min-w-[400px] 
						flex-1 
						max-sm:max-w-full 
						p-5 m-2
						rounded-md
						bg-white 
						flex flex-col
						overflow-hidden
						"
					>
						{/* heading */}
						<div className="p-2 pt-0 w-full">
							<div className="flex items-center justify-between">
								<h1 className="text-xl">Create Admin Account</h1>
							</div>
							<p className="text-dark text-sm">
								Create new admin account for a parking space
							</p>
						</div>

						{/* data */}
						<div className="w-full sm:w-[80%] h-fit m-auto flex flex-col">
							<Select
								className="text-sm"
								styles={settings.selectStyles}
								options={getPS()}
								placeholder="Select a parking space"
								onChange={(e) =>
									setNewAdmin((prev) => ({ ...prev, ps: e.value }))
								}
							/>
							<input
								type="text"
								placeholder="Name"
								className="text-sm border border-[#CCCCCC] w-full rounded px-2 py-1 my-5 focus:outline-none"
								onChange={(e) =>
									setNewAdmin((prev) => ({ ...prev, name: e.target.value }))
								}
								value={newAdmin.name}
							/>

							<div className="flex border border-[#CCCCCC] rounded overflow-hidden">
								<input
									type="text"
									placeholder="Password"
									className="text-sm rounded px-2 py-1 focus:outline-none flex-1 
									max-sm:w-[70%]"
									onChange={(e) =>
										setNewAdmin((prev) => ({
											...prev,
											password: e.target.value,
										}))
									}
									value={newAdmin.password}
								/>

								<button
									className="text-sm text-darker font-medium rounded   
									sm:px-2 sm:ml-2 focus:outline-none
									max-sm:w-[30%]
									max-sm:text-center
									"
									onClick={() => generatePassword()}
								>
									Generate
								</button>
							</div>

							{/* button */}
							<button
								className="mt-8 mx-auto bg-main w-[60%] px-5 py-1 rounded text-white font-medium
								duration-300 ease-in-out
                            hover:opacity-70
								"
								onClick={() => createNewAdmin()}
							>
								Create
							</button>
						</div>
					</div>
				</div>
			</div>

			{/* RIGHT CARDS ROW */}
			<div
				className="RIGHT-CARDS 
				flex flex-col 
			    sm:flex-[1.2]
				overflow-hidden
				sm:min-w-[500px] 
				max-sm:w-full
			"
			>
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
                    min-h-[380px] sm:min-h-[480px] h-full 
                    p-5 m-2
                    rounded-md
                    bg-white 
                    flex flex-col
                    overflow-auto
                    "
				>
					{/* heading */}
					<div className="p-2 py-0 w-full">
						<div className="flex items-center justify-between">
							<h1 className="text-xl">Search Parking Space Admins</h1>
							{/* <button
								className="text-xs text-main hover:opacity-80"
								onClick={() => navigate("/trends")}
							>
								View Details
							</button> */}
						</div>
					</div>

					{/* search */}
					<div
						className={`
						mb-4 mt-2 p-1 bg-gray-50 rounded
						`}
					>
						<div className="relative flex-1">
							<div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
								<svg
									className="w-5 h-5 text-gray-500"
									aria-hidden="true"
									fill="currentColor"
									viewBox="0 0 20 20"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fillRule="evenodd"
										d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
										clipRule="evenodd"
									></path>
								</svg>
							</div>
							<input
								type="text"
								className="w-full block p-1.5 pl-10 text-sm text-gray-900  border-gray-300 rounded bg-gray-50 focus:outline-none"
								placeholder="Search for parking spaces"
								onChange={(e) => search(e.target.value)}
							/>
						</div>
					</div>

					{/* data */}
					<div className="max-h-[calc(100vh)] 2xl:max-h-[calc(100vh-220px)] flex-1 overflow-y-auto">
						{/* table */}
						<div className="h-fit w-full overflow-y-hidden overflow-x-auto shadow-md sm:rounded">
							<div className="overflow-hidden min-w-max">
								<table className="w-full text-sm text-left text-gray-500">
									{/* head */}
									<thead className="text-xs text-gray-700 uppercase bg-gray-50">
										<tr>
											<th scope="col" className="px-6 py-3">
												Name
											</th>
											<th scope="col" className="px-6 py-3">
												Parking Space
											</th>
											<th scope="col" className="pl-12 pr-3 py-3 text-center">
												Actions
											</th>
										</tr>
									</thead>

									{/* body */}
									<tbody className="">
										{filteredAdmins.map(({ id, name, ps, status }, index) => (
											<tr
												key={index}
												className="bg-white border-b hover:bg-gray-50"
											>
												<td className="px-6 py-4 font-medium text-darker whitespace-nowrap">
													{name}
												</td>

												<td className="px-6 py-4">{ps}</td>

												<td className="py-4 flex justify-end">
													<button
														className={`px-3 py-0.5 
                                                            text-xs text-white
                                                        ${
																													status.toLowerCase() ===
																													"active"
																														? "bg-yellow-400"
																														: "bg-green-400"
																												} 
                                                        font-medium 
                                                        rounded-full
                                                        duration-200 ease-out
                                                        hover:opacity-70
                                                        cursor-pointer`}
														onClick={() => {
															if (status.toLowerCase() === "active") {
																suspendAdmin(id);
															} else {
																activateAdmin(id);
															}
														}}
													>
														{status.toLowerCase() === "active"
															? "Suspend"
															: "Activate"}
													</button>

													<button
														className={`ml-2 px-3 py-0.5 
                                                            text-xs text-white
                                                            font-medium 
                                                            rounded-full
                                                            duration-200 ease-out
                                                            hover:opacity-70
                                                            bg-main
                                                            cursor-pointer`}
														onClick={() => {
															navigate(`passwordreset/${id}`);
														}}
													>
														Reset Password
													</button>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
